import React from 'react';

/**
 * Larkwell brand glyph: a lark gliding upward with a small dawn sun.
 * Renders the white mark only — place inside the apricot tile.
 */
export const LarkwellMark = ({ className = 'h-5 w-5', stroke = 'currentColor' }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <circle cx="9.5" cy="10" r="2.4" fill={stroke} />
    <path
      d="M6 20.5 Q 11.5 17.2 15 20.5 Q 19.5 14.8 26 12"
      stroke={stroke}
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Full self-contained logo tile (apricot square + white glyph). */
export const LarkwellLogoTile = ({ size = 'h-8 w-8', glyph = 'h-5 w-5' }) => (
  <div className={`${size} rounded-xl grid place-items-center text-white shrink-0`} style={{ background: 'hsl(var(--primary))' }}>
    <LarkwellMark className={glyph} stroke="#ffffff" />
  </div>
);

export default LarkwellMark;
